<template>
  <div class="header-form">
    <slot />
  </div>
</template>

<script>

export default {
  name: 'HeaderForm',
};
</script>
